import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";
import { College } from "@/models";

const state = {
  colleges: [],
  collegesLoading: false,
  meta: {},
  college: new College(),
  collegeLoading: false,
  video: {},
  videos: [],
  limitedVideos: [],
  videosLoading: false,
  collegeImageUpload: "",
  collegeImageUploadLoading: false,
  deleteCollegeImages: [],
  deleteCollegeImagesLoading: false,
  allColleges: [],
  allCollegesLoading: false,
  count: {},
};

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
};
